import { FunctionComponent, HTMLAttributes } from 'react';

const IconCircleIHover: FunctionComponent<HTMLAttributes<HTMLOrSVGElement>> = (
  props
) => (
  <svg
    {...props}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.6576 3.89159C13.9073 1.09155 11.0292 -0.570119 8.22919 0.18015L3.89159 1.34241C1.09155 2.09268 -0.570118 4.97077 0.18015 7.77081L1.34241 12.1084C2.09267 14.9085 4.97077 16.5701 7.77081 15.8198L12.1084 14.6576C14.9085 13.9073 16.5701 11.0292 15.8199 8.22919L14.6576 3.89159Z"
      fill="currentColor"
    />
    <path
      d="M8.57756 3.45457C8.40653 3.34029 8.20546 3.2793 7.99977 3.2793C7.72394 3.2793 7.45941 3.38887 7.26437 3.58391C7.06934 3.77894 6.95977 4.04347 6.95977 4.3193C6.95977 4.52499 7.02076 4.72606 7.13504 4.89709C7.24931 5.06812 7.41174 5.20142 7.60178 5.28013C7.79181 5.35885 8.00092 5.37944 8.20266 5.33931C8.4044 5.29918 8.58971 5.20014 8.73516 5.05469C8.8806 4.90924 8.97965 4.72393 9.01978 4.52219C9.05991 4.32045 9.03932 4.11134 8.9606 3.92131C8.88189 3.73127 8.74859 3.56885 8.57756 3.45457Z"
      fill="white"
    />
    <path
      d="M5.94722 12.1318C6.06724 12.2519 6.23003 12.3193 6.39977 12.3193H9.91977C10.0895 12.3193 10.2523 12.2519 10.3723 12.1318C10.4923 12.0118 10.5598 11.849 10.5598 11.6793C10.5598 11.5096 10.4923 11.3468 10.3723 11.2267C10.2523 11.1067 10.0895 11.0393 9.91977 11.0393H8.79977V6.8793C8.79977 6.70956 8.73234 6.54677 8.61231 6.42675C8.49229 6.30673 8.3295 6.2393 8.15977 6.2393H6.87977C6.71003 6.2393 6.54724 6.30673 6.42722 6.42675C6.30719 6.54677 6.23977 6.70956 6.23977 6.8793C6.23977 7.04904 6.30719 7.21182 6.42722 7.33185C6.54724 7.45187 6.71003 7.5193 6.87977 7.5193H7.51977V11.0393H6.39977C6.23003 11.0393 6.06724 11.1067 5.94722 11.2267C5.82719 11.3468 5.75977 11.5096 5.75977 11.6793C5.75977 11.849 5.82719 12.0118 5.94722 12.1318Z"
      fill="white"
    />
  </svg>
);

export default IconCircleIHover;
